"use client";

export default function UserItem() {
  return (
    <div className="hidden sm:flex item-center justify-around gap-2 border rounded-[12px] p-2">
      <div className="avatar rounded-full min-h-12 min-w-12 bg-slate-400 flex items-center justify-center font-bold text-white ">
        <p>LA</p>
      </div>
      <div>
        <p className="text-[16px] font-bold">Legendary Apps</p>
        <p className="text-[14px]">Binij Shrestha</p>
      </div>
    </div>
  );
}
